/**
 * Shared column-type utilities used by DataExplorerTab, TableBrowser, etc.
 */
import React from 'react';
import {
  Abc as TextTypeIcon,
  Numbers as NumericTypeIcon,
  CalendarMonth as DateTypeIcon,
  CheckBox as BoolTypeIcon,
} from '@mui/icons-material';

/** Return a small coloured icon matching the dtype string. */
export function getTypeIcon(dtype: string, fontSize = 12): React.ReactNode {
  const sx = { fontSize, opacity: 0.7 } as const;
  if (/varchar|text|string|char/i.test(dtype)) {
    return <TextTypeIcon sx={{ ...sx, color: '#6366f1' }} />;
  }
  if (/int|bigint|double|float|decimal|numeric/i.test(dtype)) {
    return <NumericTypeIcon sx={{ ...sx, color: '#0891b2' }} />;
  }
  if (/date|timestamp|datetime/i.test(dtype)) {
    return <DateTypeIcon sx={{ ...sx, color: '#d97706' }} />;
  }
  if (/bool/i.test(dtype)) {
    return <BoolTypeIcon sx={{ ...sx, color: '#059669' }} />;
  }
  return null;
}

/** Human-readable short label for dtype. */
export function dtypeLabel(dtype: string): string {
  if (/varchar|text|string|char/i.test(dtype)) return 'text';
  if (/int|bigint/i.test(dtype)) return 'int';
  if (/double|float|decimal|numeric/i.test(dtype)) return 'number';
  if (/date|timestamp|datetime/i.test(dtype)) return 'date';
  if (/bool/i.test(dtype)) return 'bool';
  return dtype.toLowerCase().slice(0, 12);
}
